import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-footer-nav-1-6-0{position:relative;border-bottom:1px solid #e1e1e1}@media (min-width:600px){.hcr-footer-nav-1-6-0{border-bottom:0}}.hcr-footer-nav--first-1-6-0{border-top:1px solid #e1e1e1}@media (min-width:600px){.hcr-footer-nav--first-1-6-0{border-top:0}}.hcr-footer-nav__items-1-6-0{display:none;padding-right:12px;padding-left:12px;list-style:none}@media (min-width:600px){.hcr-footer-nav__items-1-6-0{display:block;padding-right:0;padding-left:0}}.hcr-footer-nav__items--open-1-6-0{display:block}.hcr-footer-nav__item-1-6-0{padding-bottom:12px}.hcr-footer-nav__link-1-6-0{color:#444;font-size:16px;font-weight:300;line-height:1.375em;font-weight:400;text-decoration:none}.hcr-footer-nav__link-1-6-0:hover{color:#ffad00}.hcr-footer-nav__title-1-6-0{color:#444;font-size:16px;font-weight:700;line-height:22px;position:relative;padding:12px}.hcr-footer-nav__title-1-6-0:after{display:inline-block;width:24px;height:24px;content:\"\";vertical-align:middle;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M236.4 365.9a28.2 28.2 0 0140.4 0l216.4 216.4a8.2 8.2 0 0013.6 0l216.4-216.4a28.6 28.6 0 0140.4 40.5L545.5 622.7a66.4 66.4 0 01-45.5 19.6 66.4 66.4 0 01-45.5-19.6L236.4 406.4a28.2 28.2 0 010-40.5z' fill='rgba(51, 51, 51, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%;position:absolute;top:50%;right:12px;margin-top:-11px}@media (min-width:600px){.hcr-footer-nav__title-1-6-0{padding-right:0;padding-left:0}.hcr-footer-nav__title-1-6-0:after{display:none}}.hcr-footer-nav__title--open-1-6-0:after{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M763.6 626.4a28.2 28.2 0 01-40.4 0L506.8 409.1a8.6 8.6 0 00-13.6 0L276.8 626.4a28.6 28.6 0 11-40.4-40.5l218.1-216.4A66.4 66.4 0 01500 350a66.4 66.4 0 0145.5 19.5l216.3 216.4a28.2 28.2 0 011.8 40.5z' fill='rgba(51, 51, 51, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%}",
map:{"hcr-footer-nav":"hcr-footer-nav-1-6-0","hcr-footer-nav--first":"hcr-footer-nav--first-1-6-0","hcr-footer-nav__items":"hcr-footer-nav__items-1-6-0","hcr-footer-nav__items--open":"hcr-footer-nav__items--open-1-6-0","hcr-footer-nav__item":"hcr-footer-nav__item-1-6-0","hcr-footer-nav__link":"hcr-footer-nav__link-1-6-0","hcr-footer-nav__title":"hcr-footer-nav__title-1-6-0","hcr-footer-nav__title--open":"hcr-footer-nav__title--open-1-6-0"}};

var bem = Bem('footer-nav', styles);
var FooterNav = function FooterNav(_ref) {
  var content = _ref.content,
      extraClasses = _ref.extraClasses;
  var title = content.title,
      first = content.first,
      children = content.children;
  var titleRef = React.createRef();
  var listRef = React.createRef(); // State open variable

  var open = false;

  var toggleAria = function toggleAria() {
    // browsers seem to expect strings as values, so we're not using "bool" logic in here
    var stateToSet = listRef.current.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
    listRef.current.setAttribute('aria-expanded', stateToSet);
  };

  var triggerToggle = function triggerToggle() {
    var titleElem = titleRef.current;
    var listElem = listRef.current; // @todo this is very dirty hotfix and should be refactored!
    // the reason is HoneyBem produces wrong modifier class names
    // when a mapped element class is provided as base, mod gets appended after module suffix
    // so instead of using bem.m() with specified base
    // we use bem.e() and removing the element class from it getting modifiers only

    var titleOpenMod = bem.e('title', {
      open: true
    }).replace(bem.e('title'), '').trim();
    var itemsOpenMod = bem.e('items', {
      open: true
    }).replace(bem.e('items'), '').trim();

    if (open) {
      titleElem.classList.remove(titleOpenMod);
      listElem.classList.remove(itemsOpenMod);
    } else {
      titleElem.classList.add(titleOpenMod);
      listElem.classList.add(itemsOpenMod);
    }

    toggleAria();
    open = !open;
  };

  var handleKeyPress = function handleKeyPress(event) {
    var SPACE_KEY = 32;
    var ENTER_KEY = 13;

    if (event.charCode === SPACE_KEY || event.charCode === ENTER_KEY) {
      event.preventDefault(); // disables page scrolling when space bar is pressed

      triggerToggle();
    }
  };

  return React.createElement("div", {
    className: bem.b({
      first: first
    }, extraClasses)
  }, React.createElement("span", {
    tabIndex: "0",
    role: "button",
    onClick: triggerToggle,
    onKeyPress: function onKeyPress(event) {
      handleKeyPress(event);
    }
  }, React.createElement("h4", {
    className: bem.e('title', {
      open: open
    }),
    ref: titleRef
  }, title)), React.createElement("ul", {
    className: bem.e('items'),
    ref: listRef,
    "aria-expanded": open
  }, children.map(function (_ref2, i) {
    var text = _ref2.text,
        href = _ref2.href,
        key = _ref2.key,
        RouterLink = _ref2.RouterLink;
    return React.createElement("li", {
      className: bem.e('item'),
      key: key || "".concat(text, " + ").concat(i)
    }, RouterLink ? React.createElement(RouterLink, {
      to: href,
      className: bem.e('link'),
      activeClassName: bem.m({
        active: true
      }, bem.e('link'))
    }, text) : React.createElement("a", {
      className: bem.e('link'),
      href: href
    }, text));
  })));
};
FooterNav.displayName = 'FooterNav';
FooterNav.defaultProps = {
  extraClasses: ''
};
var childrenProps = PropTypes.arrayOf(PropTypes.shape({
  text: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  RouterLink: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  key: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}));
var contentProps = PropTypes.shape({
  title: PropTypes.string.isRequired,
  first: PropTypes.bool,
  children: childrenProps
});
FooterNav.propTypes = {
  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Nav items */
  content: contentProps.isRequired
};
var footerNav = Injecss(FooterNav, styles);

export { footerNav as FooterNav };
